import { useTranslation } from 'react-i18next'

import { useTimeZone } from '../../../../../../hooks'
import { ConfirmationModal } from '../../../../../Confirmation'

import { QA_NAME_LISTING_PUBLICATION_ERROR_MODAL } from './ListingPublicationErrorModal.constants'
import { getListingPublicationErrorDescription } from './ListingPublicationErrorModal.utils'

function ListingPublicationErrorModal({ publication, onClose }) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  return (
    <ConfirmationModal
      actionButtonsProps={{ Cancel: null, submitText: t('Modal.CloseBtnKey') }}
      description={getListingPublicationErrorDescription({
        publication,
        t,
        timezone,
      })}
      qaName={QA_NAME_LISTING_PUBLICATION_ERROR_MODAL}
      title={t('RentalPortal.ListingPublicationErrorModalTitleKey')}
      onClose={onClose}
      onSubmit={onClose}
    />
  )
}

export default ListingPublicationErrorModal
